module.exports = __webpack_public_path__ + "static/media/28.a6b28118.jpg";